import AutoSpinState from './AutoSpinState';
import CascadeSpinState from './CascadeSpinState';
import EndLessSpinState from './EndLessSpinState';
import FreeSpinState from './FreeSpinState';
import NormalSpinState from './NormalSpinState';

export default class SpinState {
	constructor(scene, stateMachine) {
		this.stateMachine = stateMachine;
		this.stateObject = scene;
		this.slotControls = scene.slotControls;
		this.normalSpinState = new NormalSpinState(scene, stateMachine);
		this.freeSpinState = new FreeSpinState(scene, stateMachine);
		this.autoSpinState = new AutoSpinState(scene, stateMachine);
		this.endLessSpinState = new EndLessSpinState(scene, stateMachine);
		this.cascadeSpinState = new CascadeSpinState(scene, stateMachine);
		this.subState = null;
	}

	enterFrom(oldState) {
		console.log(this.toString() + ' - Enter From: ' + oldState.toString());
		if (this.stateObject.isCascadeSpin)
			this.subState = this.cascadeSpinState; // first cascade spins
		else if (this.slotControls.hasFreeSpin()) this.subState = this.freeSpinState;
		else if (this.slotControls.auto) this.subState = this.autoSpinState;
		else if (this.slotControls.useManualStop()) this.subState = this.endLessSpinState;
		else this.subState = this.normalSpinState;
		console.log('Spin Substate: ' + this.subState.toString());
		this.subState.enterFrom(oldState);
	}

	exitTo(newState) {
		this.subState.exitTo(newState);
		this.subState = null;
	}

	//region old
	handleInput() {}

	physicsUpdate() {}
	//endregion old

	toString() {
		return this.subState !== null ? this.subState.toString() : 'SpinState';
	}
}
